export default __webpack_public_path__ + "static/media/p2p-icon-active.10b2728d.webp";